<template>
  <!-- Gallery -->
  <div class="modal fade" id="gallery-image">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content setting-wall">
        <div class="modal-header set-wall-header">
          <h5 class="modal-title">Select Wallpaper</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="row">
          <div
            class="col-4 wallper-card-wrapper"
            v-for="(image, index) in images"
            :key="index"
          >
            <div
              class="wall-img"
              @click="selectImage(index)"
              :class="{ active: activeImageIndex === index }"
            >
              <img
                :src="require(`@/assets/img/wallpaper/${image.src}`)"
                alt="Img"
                class="img-fluid"
              />
              <div class="theme-image-content">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body wall-set-body">
          <div class="mute-chat-btn wall-btn">
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Select
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Gallery -->
</template>

<script>
export default {
  data() {
    return {
      images: [
        { src: "wallpaper-07.png", activeImageIndex: true },
        { src: "wallpaper-08.png", activeImageIndex: false },
        { src: "wallpaper-09.png" },
        { src: "wallpaper-10.png" },
        { src: "wallpaper-11.png" },
        { src: "wallpaper-12.png" },
        { src: "wallpaper-06.png" },
        { src: "wallpaper-05.png" },
        { src: "wallpaper-04.png" },
        { src: "wallpaper-03.png" },
        { src: "wallpaper-02.png" },
        { src: "wallpaper-01.png" },
        // Add more image objects here
      ],
      activeImageIndex: false,
    };
  },
  methods: {
    selectImage(index) {
      this.activeImageIndex = index;
    },
  },
};
</script>
